import { render } from "./FinancialManagementPolicy.vue?vue&type=template&id=2c3beaae&scoped=true"
const script = {}

import "./FinancialManagementPolicy.vue?vue&type=style&index=0&id=2c3beaae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3beaae"]])

export default __exports__